<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{sectionLabelAddComment[actualLanguage] }}</h3>
          
            <div class="form-group">
                <div class="col-xs-12">
                    <textarea class="form-control" v-model="comment" rows="7" placeholder="Commentaire/Comment"></textarea>
                </div>
            </div>


            <div class="form-group">
              <div class="col-sm-12 col-md-12">
                <div>
                    <p><button @click="saveChannelCommentLog()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="commentIsSaving"></spinner>
                      <span v-else><i class="fa fa-comment fa-1x push-5-r "></i>{{buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>
          

          </form>
        </div>




  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'ChannelCommentAddForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      commentIsSaving: false,
      comment : '',
      channelIndex : 0,

      actualLanguage : "FR",
      labelFieldEvName: {FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name'},

      sectionLabelAddComment:{FR: "Enregistrer un commentaire au journal de l'appareil", EN: 'Add comment to this device log book'},
      buttonLabelSave:{FR: "Enregistrer", EN: 'Save'},

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {

    saveChannelCommentLog() {
        this.commentIsSaving = true
        var requestData = { 'postAction':'SaveChannelCommentLog',
                            'bundleId': this.actualBundle.bundle_id,
                            'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
                            'localTime':moment().format('Y-MM-DDTHH:mm'),
                            'info':{'postedBy':this.profileData.profileInfo.firstName + " " + this.profileData.profileInfo.lastName,
                                    'postedById':this.profileData.profileId,
                                    'postedByEmail':this.profileData.profileInfo.email,
                                    'comment':this.comment}
                            }
                            //console.log(requestData)
        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
              //console.log(response.data)
              this.commentIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                var parameters = {'Parameter':'None'}
                this.$store.dispatch('overlayStore/setParameters',parameters)
                this.$store.dispatch('overlayStore/toggleModal',false)
                }
                else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
            })       
      
    },
  },


  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //this.channelIndex = localStorage.actualChannelIndex
    this.channelIndex = this.overlayParameters.channelIndex

  }


}
</script>



// WEBPACK FOOTER //
// ChannelCommentAddForm.vue?690d7a70